<template>
  <v-dialog 
    v-model="visible" 
    v-resize="resize"
    fullscreen 
    persistent 
    v-if="message.data" 
    id="media-gallery"
  >
    <v-card :dark="darkTheme">
      <v-btn icon @click="close" class="toolbar">
        <v-icon>close</v-icon>
      </v-btn>

      <radial-progress-bar v-if="message.type==this.types.ImageMessage && message.data.ttl>0 && !message.sent" 
        class="progressbar"
        :diameter="80"
        :completed-steps.sync="completedSteps"
        :total-steps.sync="totalSteps"
        :innerStrokeColor = "this.$vuetify.theme.baseBackground"
        :startColor = "this.$vuetify.theme.primary"
        :stopColor = "this.$vuetify.theme.primary"
      />

      <div class="timeLeft" v-if="timeLeft > 0"> {{ timeLeft }}</div>
      <div class="divContainer" :style="{ height: mediaHeight + 'px' }" v-if="message.type==this.types.ImageMessage" >
        <v-img  contain  :src="decodedPath"  />
      </div>
      <div class="divContainer" v-if="message.type==this.types.VideoMessage" >
        <ViewJs  :props="viewJs[0]" v-if="viewJs && visible" ref='video'></ViewJs>
      </div>
    </v-card>
  </v-dialog>
</template>
 
<style>
  .divContainer {
    display: flex;
    align-content: center;
    width:100%;
    height: 100%;
  }
  .toolbar {
    position: absolute !important;
    top: 10px;
    left:10px;
    z-index: 10;
    background-color: var(--v-secondary-lighten1);
  }
  .progressbar{
    position: absolute !important;
    top: 10px;
    right:10px;
    z-index: 10;
  }
  .timeLeft{
    position: absolute !important;
    top: 40px;
    right:25px;
    z-index: 10;
    width:50px;
    font-size: small;
    text-align:center;
  }
</style>

<script>
  import ViewJs from './ViewJs.vue'
  import RadialProgressBar from 'vue-radial-progress'
  import {EventBus} from '@/event-bus'
  import fileUtils from '@utils/fileUtils'

  export default {
    name: 'media-gallery',
    components: {
      ViewJs,
      RadialProgressBar
    },
    props: {
      message: {
        type: Object,
        required: true
      },
      visible: {
        type: Boolean, 
        default: false
      },
      progress:{
        type: Number,
        required: false
      }
    },
    data() {
      return {
        viewJs: [{
          allowFullScreen: true,
          preload: 'auto',
          sources: [{
            url: '',
            type: 'video/mp4'
          }]
        }],
        decodedPath: '',
        mediaHeight: 0,
        completedSteps: 2,
        totalSteps: 10,
        timeLeft: 0,
        darkTheme: false,
      }
    },
    mounted() {
      this.$nextTick(() => this.mediaHeight = window.innerHeight)
    },
    methods: {
      update() {
        this.darkTheme = this.$store.state.settings.theme

        console.log('-- message gallery', this.message)
        if (this.message.type == this.types.ImageMessage) {
          let extension = fileUtils.extension(this.message.content)
            //this.message.content.slice(this.message.content.lastIndexOf(".") + 1)

          // TODO: get it only one time
          this.$store.dispatch('decodeFile', this.message.content).then((imgData) => { 
            this.decodedPath = 'data:image/'+ extension + ';base64,' + imgData        
          })

          this.$store.dispatch('markReadChatMessage', this.message.id)
          if (this.message.data.ttl > 0) {
            this.$store.dispatch('toggleTimerMonitoring', {
              chatId: this.$store.state.currentChat.chatId, 
              monitorChat: true
            })
            this.setTimer()
          }
        } else {
          this.$store.dispatch('decodeFile', this.message.content).then((imgData) => { 
            let decryptedPath = 'data:video/mp4;base64,' + imgData        
            this.viewJs = []
            this.viewJs.push( {
              allowFullScreen: true,
              preload: 'auto',
              sources: [{
                url: decryptedPath,
                type: 'video/mp4'
              }]
            })
            //console.log('(videoData): ' + JSON.stringify(this.viewJs, null, 2))
          })
        }
      },
      close() {
        if (!this.visible)
          return
        this.$store.dispatch('markReadChatMessage', this.message.id)
        if (this.$refs.video)//&& viewJs && viewJs.length>0
          this.$refs.video.pauseVideo()
        this.$emit('update:visible', false)
      },
      setTimer() {
        ///console.log('--setTimer ttl:' + this.message.data.ttl + "progress:" + this.progress)
        let ttlLeft = this.message.data.ttl - this.progress * this.message.data.ttl / 100
        
        let date = new Date(null)
        date.setSeconds(ttlLeft)
        let s = date.toISOString()
        this.timeLeft = (this.message.data.ttl > 300) ? s.substr(11, 8) : s.substr(14, 5)

        this.totalSteps = 100
        this.completedSteps = this.progress
        ///console.log('--setTimer timeLeft:'+ this.timeLeft +" this.totalSteps:"+ this.totalSteps+" this.completedSteps:"+ this.completedSteps)
      },
      resize() {
        console.log('-- resized', window.innerWidth, window.innerHeight)
        this.mediaHeight = window.innerHeight
        this.update()
      }
    },
    watch: {
      visible: function(newValue, oldValue) {
        if (newValue) {
          this.update()
        }
      },
      progress: function() {
        //console.log('-- MediaGallery updateTtlMessageProgress: ' + this.progress)
        if (this.progress != 0 && this.message.type == this.types.ImageMessage && this.message.data.ttl > 0)
          this.setTimer()
      }
    }
  }
</script>